<template>
<div>
<div class="md-title">Food Search</div>
    <md-card style="margin-top:40px">
      <md-card-content>
        <md-field>

          <md-input ref="searchBox" @focus="clearForm" autofocus v-model="searchObj.query" placeholder="Enter UPC"></md-input>
          <md-button v-on:click = "clearForm" title="Clear"><md-icon >clear</md-icon></md-button>

          <md-button v-on:click="lookupUPC" title="Search"><md-icon >search</md-icon></md-button>
        </md-field>

          <md-field>
            <md-input v-model="searchObj.results.item_name" placeholder="Product Name"></md-input>
          </md-field>

          <md-field>
              <label for="category">SWAP Category</label>
              <md-select v-model="catValue" name="category">
                  <md-option v-bind:key="index" v-for="(cat,index) in $store.state.swapOptions" :value="cat.value">{{ cat.label }}</md-option>
              </md-select>
          </md-field>

          <md-field>
              <label for="rank">SWAP Ranking</label>
              <md-select v-model="searchObj.results.rankings.swap.rank" name="rank">
                  <md-option v-bind:key="index" v-for="(rank,index) in $store.state.swapRankings" :value="rank.value">{{ rank.label }}</md-option>
              </md-select>
          </md-field>

        </md-card-content>

      <md-card-actions md-alignment="right">
        
        <div v-if="alert.show" class="alert">{{alert.msg}}</div>
        <md-button v-if="allowManualSave" v-on:click="saveToWSG">Save To WSG</md-button>
        <md-button v-if="allowCart" v-on:click="addToCart(searchObj.results)">Add To Cart</md-button>
        <md-button v-if="this.catValue && searchObj.needLookup" v-on:click="rankNewFood" class="md-primary">Look Up</md-button>
      </md-card-actions>
    </md-card>

  <md-empty-state v-if="!$store.state.cart.items.length"
    md-icon="shopping_cart"
    md-label="0 items in cart"
    md-description="When you add items to your cart, they'll show up here.">
  </md-empty-state>

  <md-table style="margin-top:40px;" v-if="$store.state.cart.items.length">
      <md-table-toolbar style="border-bottom:1px solid #333;">
        <h1 class="md-title">Cart ({{this.totalFoodsInCart}} Foods)         
          <md-button @click="clearCart">
          Clear Cart
        </md-button>
        </h1>

        <md-button @click="showExportWindow = true" class="md-primary md-fab">
          <md-icon>cloud_upload</md-icon>
        </md-button>



      </md-table-toolbar>
      
    <md-table-row>
      <md-table-head>UPC</md-table-head>
      <md-table-head>Food</md-table-head>
      <md-table-head>Quanitity</md-table-head>
      <md-table-head>Category</md-table-head>
      <md-table-head>Rank</md-table-head>
      <md-table-head>Remove</md-table-head>
    </md-table-row>

    <md-table-row v-bind:key="index" v-for="(food, index) in $store.state.cart.items" >
      <md-table-cell>{{food.upc}}</md-table-cell>
      <md-table-cell>{{food.item_name}}</md-table-cell>
      <md-table-cell><md-field><md-input v-model="food.quantity"></md-input></md-field></md-table-cell>
      <md-table-cell>{{food.rankings.swap.category}}</md-table-cell>
      <md-table-cell>{{food.rankings.swap.rank}}</md-table-cell>
      <md-table-cell>
        <md-button v-on:click = "removeItem(index)" class="md-icon-button">
          <md-icon>remove_shopping_cart</md-icon>
        </md-button>                  
      </md-table-cell>
    </md-table-row>
  </md-table>


  <md-dialog :md-active.sync="showExportWindow">
        <md-dialog-title>Save Cart To Cloud</md-dialog-title>
        <md-dialog-content>
          
          <UserDropdown />
          
          <md-field>
            <label>Session ID (optional)</label>
            <md-input v-model="$store.state.settings.sessionId"></md-input>
          </md-field>
        </md-dialog-content>
        <md-dialog-actions md-alignment="space-between">
          <md-button @click="showExportWindow = false;">Nevermind</md-button>
          <md-button v-if="$store.state.settings.userId" @click="saveCart" class="md-primary">Upload</md-button>
        </md-dialog-actions>
  </md-dialog>



</div>
</template>

<script>
import * as firebase from 'firebase/app';
import 'firebase/firestore';

import UserDropdown from '@/components/UserDropdown.vue'

export default {
  name: 'WellScanSearch',
  data () {
    return {
      catValue:null,
      foodFound: false,
      showExportWindow : false,
      searchObj: {
        query:null,
        needLookup:false,
        category:null,
        results:{
          item_name:null,
          upc:null,
          rankings:{
            swap: {
              rank:null,
              category:null,
            }
          }
        }
      },
      defaultSearchObj : {
        query:null,
        needLookup:false,
        category:null,
        results:{
          item_name:null,
          upc:null,
          rankings:{
            swap: {
              rank:null,
              category:null,
            }
          }
        }
      },
      cart:{
        items:[]
      },

      alert: {
        show:false,
        msg:null
      },

      allowCart:false,
      allowManualSave:false,
    }
  },
  computed: {
    settings : function(){
      return this.$store.state.settings
    },

    totalFoodsInCart: function() {
      var tot = 0;
      
      for(var k in this.cart.items) tot += +this.cart.items[k].quantity;

      return tot;

    }
  },

  methods: {
    lookupUPC:function() {
      // if we don't already know whether it's found
      axios.get('//api.wellscan.io/api/getFoodInfo/' + this.searchObj.query, { crossdomain: true }).then((response)  =>  {
          if(response.data.status == 200) {
              this.searchObj.results = response.data;
              this.catValue = this.searchObj.results.rankings.swap.category;
              this.foodFound = true;
              this.allowCart = true;
              
            }
          if (response.data.status == 404) {
              this.searchObj.needLookup = true;
              this.alert.msg = "Hmm...that food wasn't in WellScan Global. Enter a SWAP category to look it up.";
              this.alert.show = true;
              this.allowCart = false;
              this.allowManualSave = false;
          }
        }, 
        (error)  =>  {
          console.log("there was an error.");
        })
    },

    rankNewFood:function(){
      // go get the information from the nutrition data sources and do the thing.
      axios.get('//api.wellscan.io/api/swap/' + this.catValue + "/" + this.searchObj.query, { crossdomain: true }).then((response)  =>  {
          if(response.status == 200) {

              this.searchObj.needLookup = false;
              this.foodFound = true;
              this.allowCart = true;
              this.alert.show = false;
              var d = response.data;

              var ret= { 
                item_name:d.name,
                upc:d.barcode,
                rankings:{
                  swap: {
                    rank:d.rank,
                    category:d.category,
                  }
                }
              };
              this.searchObj.results = ret;
            }
          if (response.status !== 200) {
              this.searchObj.needLookup = false;
              this.alert.msg = "Nutrition information could not be obtained. You can still add the item to your cart, though. You can also add it to WellScan Global."
              this.allowCart = true;
              this.allowManualSave = true;
              this.alert.show = true;
          }
        }, 
        (error)  =>  {
            this.searchObj.needLookup = false;
            this.alert.msg = "Nutrition information could not be obtained. You can still add the item to your cart, though. You can also add it to WellScan Global."
            this.allowCart = true;
            this.allowManualSave = true;
            this.alert.show = true;
        })
    },

    saveCart() {
      // Initialize Cloud Firestore through Firebase

      var db = firebase.firestore();
      var cartName = this.$store.state.settings.sessionId || Date.now().toString();
      var that = this;
      console.log(cartName);

      db.collection("users")
      .doc(this.$store.state.settings.userId)
      .collection("carts")
      .doc(cartName)
      .set({
        dateSaved: new Date(),
        items:this.cart.items
      },
       {merge:true}
      )
      .then(function(docRef) {
          that.$router.push('reports')
          console.log("Your cart has been saved.");
      })
      .catch(function(error) {
          console.error("Error adding document: ", error);
      });
    },

    saveToWSG() {
      this.searchObj.results.rankings.swap.category = this.catValue;
      var db = firebase.firestore();
      db.collection("foods")
      .doc(this.searchObj.query)
      .set({
        item_name:this.searchObj.results.item_name,
        rankings:this.searchObj.results.rankings,
        info_src:"manual",
        savedBy: this.$store.state.settings.userId || "anonymous"
      });

      this.alert.msg = "Food saved to WellScan Global";
      this.clearForm();

    },

    setSearchObjCategory: function(){
      this.searchObj.category = this.catValue;
    },

    addToCart(product) {
      if(!product.upc)
        product.upc = this.searchObj.query;

      this.cart.items.unshift({
        item_name: product.item_name,
        upc:this.searchObj.query,
        quantity: 1,
        rankings:{
          swap: {
            category:this.catValue,
            rank: this.searchObj.results.rankings.swap.rank
          }
        }
      });

      this.$store.state.cart = this.cart;

      this.clearForm();
      this.allowManualSave = true;
    },

    removeItem(index){
      let food = this.cart.items[index];
      this.cart.items.splice(index, 1);
      this.$store.state.cart = this.cart;
    },

    clearForm(){
      for(var k in this.defaultSearchObj) this.searchObj[k]=this.defaultSearchObj[k];
      this.searchObj.results.item_name = null;
      this.searchObj.results.rankings.swap.rank = null;
      this.catValue = null;
      this.foodFound = false;
      this.allowCart = false;
      this.needLookup = false;
      this.alert.show = false;
      this.allowManualSave = false;
      console.log(this.searchObj);
      this.alert.msg = "";
      this.$refs.searchBox.$el.focus();

    },

    clearCart() {
      this.cart.items = [];
      this.$store.state.cart = this.cart;
    }

  },

  watch: {
    catValue(){
      console.log(this.catValue);
      //console.log(this.searchObj.results)
      if(this.foodFound) {
        if(this.catValue != this.searchObj.results.rankings.swap.category) {
          this.alert.msg = "You changed the category of this product, so you should re-run the rules";
          this.alert.show = true;
          this.searchObj.needLookup = true;
          this.allowCart = false;
        }
      }
    },
  },
  props: {
    upc: String
  },

  components: {
    UserDropdown  
  },
  mounted: function () {
    if(this.$store.state.cart.items.length && !this.cart.items.length)
      this.cart = this.$store.state.cart;
  },
}
</script>

<style>
  .rank-result, .alert {
    padding:5px;
  }

  .alert {
    background:lavender;
  }
  .yellow {
    background-color:yellow;
    color:black;
  }

  .red {
    background-color:red;
  }

  .green {
    color:darkgreen;
    background-color:green;
  }
</style>